export function sendDataToParent(value: any) {
    // console.log('parent data: ', value);
    window.parent.postMessage(value, '*');
}
